import { Directive, ElementRef, HostListener, Input, NgModule } from '@angular/core';

@Directive({
  selector: '[appSystemDropdownDismiss]',
})
export class DropdownDismissDirective {
  @Input() appDropdownClose!: ElementRef | HTMLElement; // Allow ElementRef or native element

  constructor() {}

  // Close the dropdown when an element inside it is clicked
  @HostListener('click', ['$event'])
  handleElementClick() {
    const dropdown = this.getNativeElement(this.appDropdownClose);
    dropdown.classList.replace('block', 'hidden');
  }

  // Close the dropdown when the ESC key is pressed
  @HostListener('document:keydown.escape', ['$event'])
  handleEscapeKey() {
    const dropdown = this.getNativeElement(this.appDropdownClose);
    dropdown.classList.replace('block', 'hidden');
  }

  // Helper method to handle ElementRef or native element
  private getNativeElement(element: ElementRef | HTMLElement): HTMLElement {
    return element instanceof ElementRef ? element.nativeElement : element;
  }
}

@NgModule({
  declarations: [DropdownDismissDirective],
  exports: [DropdownDismissDirective],
})
export class SystemDropdownDismissModule {}
